let control = {
  state: null,
  grabWindowXPosition: null,
  grabWindowYPosition: null,
  handGrabXPoistion: null,
  handGrabYPosition: null,
  handX: [],
  handY: [],
  rollingAverage: 0,
};

export function handleScrollByGesture(pinch, predictions) {
  if (predictions == undefined || predictions.length == 0) return;
  let prediction = predictions[0];
  if (pinch) {
    let x = prediction.annotations.indexFinger[3][0];
    let y = prediction.annotations.indexFinger[3][1];
    if (control.state != 'pinch') {
      control.grabWindowXPosition = window.scrollX;
      control.grabWindowYPosition = window.scrollY;
      control.handGrabXPoistion = x;
      control.handGrabYPosition = y;
      control.handX = [x, x, x, x, x];
      control.handY = [y, y, y, y, y];
      control.state = 'pinch';
    }
    // move window relative to grab
    control.handX[control.rollingAverage] = x;
    control.handY[control.rollingAverage] = y;
    control.rollingAverage = (control.rollingAverage + 1) % 5;
    var handDeltaY =
      control.handY.reduce((sum, v) => sum + v, 0) / control.handY.length -
      control.handGrabYPosition;
    var handDeltaX =
      control.handX.reduce((sum, v) => sum + v, 0) / control.handX.length -
      control.handGrabXPoistion;
    const scale = 10;
    window.scrollTo(
      control.grabWindowXPosition + handDeltaX * scale,
      control.grabWindowYPosition - handDeltaY * scale,
    );
  } else {
    if (control.state == 'pinch') {
      console.log('unpinch');
    }
    control.state = 'something';
  }
}
